import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-buttons" }

import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import Pagination from '@/components/Pagination.vue'
import { getScalperListApi, changeScalperTypeApi, markRealScalperApi } from '@/apis/user'
import { openRouteInNewWindow } from '@/utils/router-helper'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'

enum RecordType {
    '疑似黄牛',
    '黄牛',
    '白名单',
    '继续观察'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ScalperList',
  setup(__props) {

const loading = ref(false)
const tableData = ref([])
const total = ref(0)
const filters = reactive({
    uid: '',
    uname: '',
    phone: '',
    channel: '',
    record_type: '',
    page: 1,
    page_size: 10
})

const getList = async () => {
    loading.value = true
    try {
        const { code, data, msg } = await getScalperListApi(filters) as any
        if (code != 200) {
            ElMessage.error(msg || '获取数据失败')
            return
        }
        tableData.value = data.data
        total.value = data.total
    } catch (err) {
        console.error(err)
    } finally {
        loading.value = false
    }
}

const onSearch = () => {
    filters.page = 1
    getList()
}

const onExport = () => {
    window.open(`${Keys.baseUrl}/sys/admin/getBlacklist?${joinParams({ ...filters, is_export: 1 })}`)
}

const onPageChange = (val: number) => {
    filters.page = val
    getList()
}

const onSizeChange = (val: number) => {
    filters.page_size = val
    getList()
}

const toUserDetail = (userId: number | string, type) => {
    openRouteInNewWindow({
        path: `/user/user-${type}`,
        query: {
            id: userId
        }
    })
}

const toUserOrder = (userId: number) => {
    openRouteInNewWindow({
        path: `/user/user-order`,
        query: {
            id: userId
        }
    })
}

const onStatusChange = async (id: number | string, val: number | string) => {
    const { code, msg } = await changeScalperTypeApi(id, val) as any
    if (code != 200) return ElMessage.error(msg || '操作失败')

    ElMessage.success('状态变更成功')
    getList()
}

const onMarkRealScalper = (userId: number | string) => {
    ElMessageBox.confirm('确定将用户标记为真实黄牛吗,标记后用户将无法登陆?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(async () => {
        const { code, msg } = await markRealScalperApi(userId) as any
        if (code == 1 || code == 200) {
            ElMessage.success('标记成功')
            getList()
        } else {
            ElMessage.error(msg || '操作失败')
        }
    })
}

onMounted(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        modelValue: filters.uid,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.uid) = $event)),
        modelModifiers: { trim: true },
        placeholder: "用户ID",
        class: "filter-item",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: filters.uname,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.uname) = $event)),
        modelModifiers: { trim: true },
        placeholder: "用户名",
        class: "filter-item",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: filters.phone,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.phone) = $event)),
        modelModifiers: { trim: true },
        placeholder: "手机号",
        class: "filter-item",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: filters.channel,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.channel) = $event)),
        modelModifiers: { trim: true },
        placeholder: "渠道",
        class: "filter-item",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.record_type,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.record_type) = $event)),
        placeholder: "标记状态",
        class: "filter-item",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "疑似黄牛",
            value: 0
          }),
          _createVNode(_component_el_option, {
            label: "黄牛",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "白名单",
            value: 2
          }),
          _createVNode(_component_el_option, {
            label: "继续观察",
            value: 3
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "filter-btn",
        onClick: onSearch
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        class: "filter-btn",
        onClick: onExport
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      border: "",
      stripe: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "user_id",
          label: "用户ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "用户名",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "userphone",
          label: "手机号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "最后绑卡渠道"
        }),
        _createVNode(_component_el_table_column, {
          prop: "current_channel",
          label: "当前渠道"
        }),
        _createVNode(_component_el_table_column, { label: "用户状态" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, {
              type: row.record_type == '黄牛' ? 'danger' : 'success'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.record_type == '黄牛' ? '禁用' : '正常'), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "record_type",
          label: "类型"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(RecordType[row.record_type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: ($event: any) => (toUserDetail(row.user_id, 'show'))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: ($event: any) => (toUserDetail(row.user_id, 'edit'))
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("编辑")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                onClick: ($event: any) => (toUserOrder(row.user_id))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode("消费行为")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (RecordType[row.record_type] != '黄牛')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    link: "",
                    class: "ml0 mr10 mt5",
                    type: "danger",
                    onClick: ($event: any) => (onMarkRealScalper(row.user_id))
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("标记真黄牛")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_select, {
                modelValue: row.record_type,
                "onUpdate:modelValue": ($event: any) => ((row.record_type) = $event),
                size: "small",
                class: "mt5",
                onChange: (val) => onStatusChange(row.id, val),
                style: {"width":"90px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "疑似黄牛",
                    value: 0
                  }),
                  _createVNode(_component_el_option, {
                    label: "黄牛",
                    value: 1
                  }),
                  _createVNode(_component_el_option, {
                    label: "白名单",
                    value: 2
                  }),
                  _createVNode(_component_el_option, {
                    label: "继续观察",
                    value: 3
                  })
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})